import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
// hooks
import useAuth from "../hooks/useAuth";
// pages
import Registered from "src/pages/auth/Registered";
// routes
import { PATH_DASHBOARD } from "../routes/paths";
import HealthCheck from "src/components/global/HealthCheck";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isRegistered } = useAuth();
  const location = useLocation();


  if (isAuthenticated) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  } else if (!isAuthenticated && isRegistered) {
    return <Registered />;
  }

  return <Box display={'flex'} flexDirection={'column'}>

    {/* Dont Show the health banner on home page  */}

    {
      location.pathname !== '/' && <HealthCheck />
    }
    {children}
  </Box>;
}
